const contactInfo = [
  {
    label: "Address",
    value: "AVALSKA 25",
    icon: "ri-map-pin-line",
  },
  {
    label: "City",
    value: "Lepenica",
    icon: "ri-building-line",
  },
  {
    label: "Zip",
    value: "633740",
    icon: "ri-mail-open-line",
  },
  {
    label: "Country",
    value: "Serbia",
    icon: "ri-global-line",
  },
  {
    label: "Email",
    value: "info@kircidoo.com",
    icon: "ri-at-line",
  },
  {
    label: "Phone",
    value: "+1 6627296771",
    icon: "ri-phone-line",
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="bg-[#111318] rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Left: Heading */}
            <div className="p-12 md:p-16 lg:p-20 flex flex-col justify-between">
              <div>
                <span className="text-xs uppercase tracking-[0.25em] text-white/30 font-medium">Reach Out</span>
                <h2 className="text-4xl md:text-5xl font-thin text-white mt-4 leading-tight tracking-tight">
                  Get In Touch
                </h2>
                <div className="w-12 h-px bg-white/20 mt-6 mb-8" />
                <p className="text-white/50 text-sm leading-relaxed max-w-sm">
                  Have questions about our products or want to learn more about KIRCI DOO? We&apos;d love to hear from you. Reach out through any of the channels below.
                </p>
              </div>

              {/* Logo watermark area */}
              <div className="mt-12 flex items-center gap-4 opacity-30">
                <img
                  src="https://public.readdy.ai/ai/img_res/7c732112-4909-4323-8a23-e32da04c1d7a.png"
                  alt="KIRCI DOO"
                  className="h-10 w-auto object-contain"
                />
                <span className="text-white text-lg font-light tracking-widest">KIRCI DOO</span>
              </div>
            </div>

            {/* Right: Contact Info */}
            <div className="p-12 md:p-16 lg:p-20 border-t lg:border-t-0 lg:border-l border-white/10">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                {contactInfo.map((item) => (
                  <div key={item.label} className="flex items-start gap-4">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-white/50 text-base`} />
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-widest text-white/30 font-medium mb-1">
                        {item.label}
                      </p>
                      <p className="text-white/80 text-sm font-light">{item.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-white/10 px-12 md:px-16 lg:px-20 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-white/20 text-xs">
              &copy; {new Date().getFullYear()} KIRCI DOO. All rights reserved.
            </p>
            <p className="text-white/20 text-xs">iOS App Development &bull; Serbia</p>
          </div>
        </div>
      </div>
    </section>
  );
}
